export class Auditoria {
    iP: string;
    navegador: string;
    versaoNavegador: string;
}
